import styled from 'styled-components';

export const StyledDefsSvg = styled.svg`
   position: absolute;
   width: 0;
   height: 0;
`;

StyledDefsSvg.displayName = 'StyledDefsSvg';
